import { FourDotFivePhoneNumberComponent } from "./four-dot-five-phone-number.component";
export const FourDotFivePhoneNumberModule = angular
    .module('fourDotFivePhoneNumber', [])
    .component(FourDotFivePhoneNumberComponent.selector, FourDotFivePhoneNumberComponent.component)
    .name;
//# sourceMappingURL=four-dot-five-phone-number.module.js.map